export enum EStatusConciliacaoOfx{
    NaoConciliado = 1,
    Conciliado = 2,
    Ignorado = 3,
}
